import { useQuery } from "@tanstack/react-query";
import { api } from "../context";
import { MedicineSearch } from "../interfaces";
import { millisecondsInMinute } from "date-fns";

interface UseSearchProductsProps {
  query: string;
  enabled?: boolean;
}

export const useSearchProducts = ({ query, enabled = true }: UseSearchProductsProps) =>
  useQuery({
    queryKey: ["search-products", query],
    queryFn: () => {
      const params = new URLSearchParams();
      params.set("query", query.toLowerCase());
      return api<MedicineSearch>({
        url: `/search?` + params.toString(),
      });
    },
    enabled: enabled && !!query,
    staleTime: 0.5 * millisecondsInMinute,
  });
